var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplementaryMedicineWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "complementary-medicine-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".complementary-medicine-white_svg__st7{fill:none;stroke:#fff;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.2 659.4H38.9V362.7h321.8V38.9h297.7v283.3M360.7 894.5v89.6h297.7V830.9M880 362.7h103.1v296.7H831.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M661 548.1s-95.6 65.9-193.4 55.4C379 594 308 671 308 671s-55.1-95.4 72.8-185.8 296.7 8.9 393.5-69.6c0 0 12.5 284.3-188.8 339.7s-260.3.4-260.3.4-37 12.3-45.4 80.4"
  })));
}

export default SvgComplementaryMedicineWhite;